<template>
  <div style="height: 80px; display: flex; justify-content: flex-start; align-items: center;">
    <PostTypeTabs
      v-model="selectedType"
      :tabs="availableTabs"
    />
  </div>
  <div class="row justify-center screen-height">
      <div class="col-8">
        <home-posts 
          class="flex-h-50"
          :selected-type="selectedType"
          @update:selected-type="selectedType = $event"
        />
        <div class="row flex-h-50">
          <div class="col-6"><latest-blog-post class="flex-h-100"/></div>
          <div class="col-6 quick-links">
            <p style="color: #73726F;">Quick Links</p>
            <a class="quick-link" href="#">
              Forms
              <span class="view-button">View <i class="fas fa-chevron-right" style="margin-bottom: 1px; font-size: 75%;"></i></span>
            </a>
            <a class="quick-link" href="#">
              Portfolio
              <span class="view-button">View <i class="fas fa-chevron-right" style="margin-bottom: 1px; font-size: 75%;"></i></span>
            </a>
            <a class="quick-link" href="#">
              Notion
              <span class="view-button">View <i class="fas fa-chevron-right" style="margin-bottom: 1px; font-size: 75%;"></i></span>
            </a>
            <a class="quick-link" href="#">
              Reusable Code
              <span class="view-button">View <i class="fas fa-chevron-right" style="margin-bottom: 1px; font-size: 75%;"></i></span>
            </a>
            <a class="quick-link" href="#">
              Licenses
              <span class="view-button">View <i class="fas fa-chevron-right" style="margin-bottom: 1px; font-size: 75%;"></i></span>
            </a>
            <a class="quick-link" href="#">
              Assets Folder
              <span class="view-button">View <i class="fas fa-chevron-right" style="margin-bottom: 1px; font-size: 75%;"></i></span>
            </a>
            <a class="quick-link" href="#">
              Tools - Internal Link
              <span class="view-button">View <i class="fas fa-chevron-right" style="margin-bottom: 1px; font-size: 75%;"></i></span>
            </a>
          </div>
        </div>
      </div>
      <div class="col-4">
          <updates-block class="flex-h-100"/>
      </div>
  </div>
  <div class="row">
    <div class="col-12">
      <instagram-feed />
    </div>
  </div>
</template>

<script>
import homePosts from '@/components/Home/HomePosts.vue';
import updatesBlock from '@/components/UpdatesBlock.vue';
import PostTypeTabs from '@/components/Home/PostTypeTabs.vue';
import InstagramFeed from '@/components/Home/InstagramFeed.vue';
import LatestBlogPost from '@/components/Home/LatestBlogPost.vue';

export default {
  name: 'Home',
  components: {
    homePosts,
    updatesBlock,
    PostTypeTabs,
    InstagramFeed,
    LatestBlogPost,
    
  },
  data() {
    return {
      selectedType: 'all',
      availableTabs: [
        { type: 'all', label: 'All Posts' },
        { type: 'announcement', label: 'Announcements' },
        { type: 'training', label: 'New Trainings' }
      ]
    };
  }
}
</script>

<style scoped>
.quick-links{
  gap: .5em;
}
.quick-links p {
  margin: 0;
  font-weight: 600;
}

.quick-link {
  background-color: #F9F8F6;
  padding: 10px 20px;
  border-radius: 30px;
  position: relative;
  transition: 0.2s;
  color: #73726F;
  border: 1px solid #fff;
  text-decoration: none;
}

.quick-link:hover {
  background-color: #fff;
  border-color: #d5d1c8;
}

.view-button {
  display: inline-block;
  font-size: 0.85em;
  white-space: nowrap;
  padding-right: 1em;
  position: absolute;
  right: 10px;
}
</style>